exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.customSelect[data-v-f10f4eb6]{display:inline-flex}div.customSelect span[data-v-f10f4eb6]{padding:.2em 1em;border:1px solid #007bff;background:#1a88ff;cursor:pointer;text-transform:uppercase;font-size:.8em;color:#fff;font-weight:700}div.customSelect span.active[data-v-f10f4eb6]{background:#006fe6}div.customSelect span[data-v-f10f4eb6]:first-child{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}div.customSelect span[data-v-f10f4eb6]:last-child{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f10f4eb6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LanguageSelector.vue
// module id = 101
// module chunks = 0